import React from "react";

/**
 * "Bot is typing" indicator — three bouncing dots in a chat-bubble shell.
 * Bouncing freezes under prefers-reduced-motion via the global CSS rule
 * (styles.css §Phase 6 reduced-motion path); the dots stay visible so
 * the visitor still knows the bot is thinking. The wrapper carries an
 * aria-live + label so screen readers announce "Typing" instead of
 * silently rendering three unlabeled bullets.
 */
export function TypingIndicator(): React.ReactElement {
  return (
    <div className="mb-3 flex items-end" role="status" aria-live="polite" aria-label="Typing">
      <div className="flex items-center gap-1 rounded-2xl rounded-bl-sm bg-grey-100 px-4 py-3">
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-grey-400" style={{ animationDelay: "0ms" }} />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-grey-400" style={{ animationDelay: "150ms" }} />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-grey-400" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
}
